export const newsType = [
  {
    type: 1,
    value: "Actualité",
  },
  {
    type: 2,
    value: "Recrutement",
  },
 
];

export const getNewsTypeString = (type) => {
  switch (type) {
    case 1:
      return "Actualité";

    case 2:
      return "Recrutement";


    default:
      return "Inconnu";
  }
};